var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgAmethystGemOutline = function SvgAmethystGemOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 728 728",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393.25 25L403.25 24.5L588.25 264L620.75 474.5L559.75 591L475.75 668.5L365.75 703.5L291.75 675.5L110.75 466L107.25 270L232.75 103.5L393.25 25Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgAmethystGemOutline);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/status/amethyst-gem-outline.ec46aea9fc2f395010dc153f664b1c9a.svg";